export const normalizeComparableText = (value) => String(value || "")
  .normalize("NFKD")
  .replace(/[\u0300-\u036f]/g, "")
  .replace(/\s+/g, " ")
  .trim()
  .toLowerCase();

export const isUnitedStatesCoin = (coin = {}) => {
  const authorityCode = String(coin.country_authority_code || "").toLowerCase();
  if (authorityCode === "iso2:us" || authorityCode === "manual:united_states") {
    return true;
  }
  const country = normalizeComparableText(coin.country || "");
  return country === "united states" || country === "usa" || country === "us";
};

const hasMintValue = (coin = {}, metadata = {}) => [
  coin.mint,
  coin.mint_code,
  metadata.mint_raw,
  metadata.mint_canonical_display,
].some((value) => String(value || "").trim());

const resolveMintShortCode = (coin = {}, metadata = {}) =>
  String(coin.mint_short_code || metadata.mint_short_code || "").trim().toUpperCase();

const resolveCoinYear = (coin = {}, metadata = {}) => {
  const year = coin.year ?? metadata.year;
  if (year === null || year === undefined || year === "") {
    return null;
  }
  const yearToken = String(year).trim();
  return /^-?\d{1,4}$/.test(yearToken) ? yearToken : null;
};

export const applyUsMintCodeToTitle = (baseTitle, coin = {}, metadata = {}) => {
  const title = String(baseTitle || "").trim();
  if (!title || !isUnitedStatesCoin(coin) || !hasMintValue(coin, metadata)) {
    return title;
  }
  const shortCode = resolveMintShortCode(coin, metadata);
  if (!/^[A-Z0-9]{1,2}$/.test(shortCode)) {
    return title;
  }
  const yearToken = resolveCoinYear(coin, metadata);
  if (!yearToken) {
    return title;
  }
  if (title.includes(`${yearToken}-${shortCode}`)) {
    return title;
  }
  if (title.endsWith(` ${yearToken}`)) {
    return `${title}-${shortCode}`;
  }
  return title;
};

export const buildYearBadgeValue = (coin = {}, metadata = {}) => {
  return resolveCoinYear(coin, metadata);
};

export const buildMintBadgeValue = (coin = {}, metadata = {}) => {
  const canonicalMint = String(metadata.mint_canonical_display || "").trim();
  if (canonicalMint) {
    return canonicalMint;
  }
  const rawMint = String(coin.mint || metadata.mint_raw || "").trim();
  if (rawMint) {
    return rawMint;
  }
  return null;
};
